import { Injectable } from '@angular/core';
import { AuthService } from '@gelato-api-ui/core/auth/auth.service';
import { ECommerceStoreMetadataApiService } from '@gelato-api-ui/core/e-commerce/services/e-commerce-store-metadata-api.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, switchMap, withLatestFrom } from 'rxjs/operators';
import * as actions from './header-create-menu.actions';
import * as selectors from './header-create-menu.selectors';
import { PublisherMetadataKeys } from '@api-ui-app/src/app/header-create-menu/constant/meta-data-keys';

@Injectable()
export class HeaderCreateMenuEffects {
  clientId$ = this.authService.getClientId();

  constructor(
    private readonly actions$: Actions,
    private readonly store: Store,
    private readonly authService: AuthService,
    private readonly eCommerceStoreMetadataApiService: ECommerceStoreMetadataApiService,
  ) {}

  loadUploadDesignLeftLimits$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.loadUploadDesignLeftLimits),
      withLatestFrom(this.clientId$),
      switchMap(([, clientId]) =>
        this.eCommerceStoreMetadataApiService.get({
          clientId,
          keys: [PublisherMetadataKeys.UPLOAD_DESIGN_LIMIT_METADATA_KEY],
        }),
      ),
      map(response => actions.uploadMetadataSuccess({ metadata: response?.metadata })),
    ),
  );

  updateUploadDesignLeftLimits$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.updateUploadDesignLeftLimitsMetadata),
      withLatestFrom(this.store.select(selectors.getUploadedDesignsCount)),
      switchMap(([{ storeId }, oldLimits]) =>
        this.eCommerceStoreMetadataApiService.update(storeId, {
          storeId,
          metadata: [{ key: PublisherMetadataKeys.UPLOAD_DESIGN_LIMIT_METADATA_KEY, value: `${++oldLimits}` }],
        }),
      ),
      map(response => actions.uploadMetadataSuccess({ metadata: response?.metadata })),
    ),
  );
}
